/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React, { Component } from 'react';
import PropTypes from 'prop-types';

const propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
};

const defaultProps = {
    className: '',
};

export default class PageRegion extends Component {
    render() {
        const classes = `rec-region-outer-wrap ${this.props.className}`;

        return <div className={classes}>{this.props.children}</div>;
    }
}

PageRegion.propTypes = propTypes;
PageRegion.defaultProps = defaultProps;
